import React from 'react';
import { DollarSign, Users, Activity, TrendingUp } from 'lucide-react';
import type { AggregateMetrics } from '../../lib/types';
import { MetricCard } from './MetricCard';
import { formatCurrency, formatPercentage } from './formatters';

interface AggregateMetricsSectionProps {
  aggregate: AggregateMetrics;
}

export const AggregateMetricsSection: React.FC<AggregateMetricsSectionProps> = ({ aggregate }) => {
  const aggregatePnlTrend = aggregate.totalPnl > 0 ? 'up' : aggregate.totalPnl < 0 ? 'down' : 'neutral';

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <MetricCard
        title="Total P&L (USDT)"
        value={formatCurrency(aggregate.totalPnl)}
        icon={<DollarSign className="h-8 w-8" />}
        trend={aggregatePnlTrend}
        description="All users combined"
      />
      <MetricCard
        title="Active Traders"
        value={aggregate.totalUsers.toString()}
        icon={<Users className="h-8 w-8" />}
        description="Users with production API keys"
      />
      <MetricCard
        title="Total Trades"
        value={aggregate.totalTrades.toString()}
        icon={<Activity className="h-8 w-8" />}
        description="Executed in selected period"
      />
      <MetricCard
        title="Avg Win Rate"
        value={formatPercentage(aggregate.averageWinRate)}
        icon={<TrendingUp className="h-8 w-8" />}
        trend={aggregate.averageWinRate > 50 ? 'up' : 'down'}
        description="Across all traders"
      />
    </div>
  );
};
